import striptags from "striptags";

/**
 * Clean up a string so it can be displayed in tiles, etc.
 * Removes HTML tags, fixes spaces.
 *
 * @param {String} string
 */
function strClean(string) {
  return striptags(string)
    .replace(/\./g, ". ") // add space after any periods (can be removed by stripping tags)
    .replace(/ {1,}/g, " "); // remove double spaces
}

/**
 * Truncate a string to the specified length.
 * Adds ellipsis.
 *
 * @param {String} string
 * @param {Number} maxLength
 */
function strTruncate(string, maxLength) {
  if (string.length > maxLength) {
    string = string.substring(0, maxLength) + "...";
  }
  return string;
}

/**
 * Convert a string to HTML character (entity) codes, e.g. for e-mail address obfuscation.
 *
 * @param {String} str
 */
function strToHtmlCodes(str) {
  let code = "";
  [...str].forEach((c) => {
    code += `&#${c.charCodeAt()};`;
  });
  return code;
}

/**
 * A hacky approach to converting a string containing HTML character (entity) codes to their original characters.
 * An alternative is to use the NPM he (HTML Entities) library, although it is quite long in the tooth.
 *
 * @param {String} html
 */
function htmlCodesToStr(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

/**
 * Capitalise the first letter in a the supplied string.
 * @param {String} str
 * @returns {String}
 */
function strCapitaliseFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export { strCapitaliseFirst, strClean, strToHtmlCodes, htmlCodesToStr, strTruncate };
